<template>
    <tr class="ds-table__row">
        <slot></slot>
    </tr>
</template>
